import React from 'react';
//import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
const Paging = (props) => {

  //console.log('page props', props);

  let total = props.total ? props.total : 0;
  let limit = props.limit ? parseInt(props.limit) : 0;
  let page = props.page ? parseInt(props.page) : 1;
  let additional = props.additional ? props.additional : null;
  //console.log('limit', limit);
  let pageMax = limit > 0 ? Math.ceil(total/limit) : 0;
  let base = props.base ? props.base : '';
  let classStyles = props.classStyles ? props.classStyles : '';

  let extra = ''
  if(additional != null) {
    if(typeof additional == "object"){
      //json format
      let keys = Object.keys(additional);
      keys.forEach((key, k)=> {
        //console.log('key:' + key);
        if(additional[key] != null){
          //TODO:url encode if needed
          extra += `&${key}=${additional[key]}`;
        }
      })
    } else {
      //just a string
      if(!additional.startsWith("&")){
        extra = "&" + additional
      } else {
        extra = additional;
      }
      
    }
  }


  //console.log(`page: ${page} limit ${limit} total ${total}`)
  return (
    <div className={classStyles}>
      {page > 1 ? (
        <Link to={`${base}?page=${(page - 1)}&limit=${limit}${extra}`} className="btn btn-secondary btn-sm me-2">prev</Link>
      ) :null}
      {page < pageMax ? (
        <Link to={`${base}?page=${(page + 1)}&limit=${limit}${extra}`} className="btn btn-secondary btn-sm">next</Link>
      ) : null}
    </div>
  )
}

export default Paging;